// @flow
import React from 'react';
import { withRouter } from 'react-router-dom';
import { Banner } from 'components/atoms/banner';
import { GoToBrowser } from 'components/atoms/goToBrowser';
import { useViewport } from 'components/templates/viewportProvider';
import { FooterExploreButton } from 'components/atoms/footerExploreButton';
// eslint-disable-next-line
import styles from "./styles.scss";

// TODO:
type Props = {
  data: {
    imageUrl: any,
    backButtonText?: string,
    onBackPress: () => void,
    bannerData: Object,
  },

  fullpageApi: {
    moveSectionDown: () => void,
  },
  theme: string,
};

const ComingSoonBanner = (props: Props) => {
  const { height, isMobile } = useViewport();
  const {
    backButtonText,
    onBackPress,
    bannerData: { image, image_mobile, thumbnail, title },
  } = props.data;
  const { fullpageApi, theme } = props;
  let className = 'coming-soon-banner';
  let bannerImage = image;
  let thumbNailUrl = thumbnail;
  if (isMobile) {
    bannerImage = image_mobile;
  }

  const handleClick = () => {
    fullpageApi.moveSectionDown();
  };

  return (
    <div className={className} style={{ height }} id={'banner'}>
      <Banner
        containerClassName={'banner-image'}
        imageUrl={bannerImage}
        thumbNailUrl={thumbNailUrl}
        title={title ? title : 'Coming Soon'}
      />
      {backButtonText && (
        <GoToBrowser
          onClick={onBackPress}
          buttonName={backButtonText}
          containerClassName={'navigate-to-browser'}
        />
      )}
      {/*<FooterExploreButton onClick={handleClick} theme={theme} />*/}
    </div>
  );
};

export default withRouter(ComingSoonBanner);
